var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1281 0.64441C13.2531 0.769428 13.3233 0.938967 13.3233 1.11574C13.3233 1.29252 13.2531 1.46206 13.1281 1.58708L5.63346 9.08241C5.56536 9.15054 5.4845 9.20459 5.39551 9.24146C5.30651 9.27834 5.21113 9.29732 5.1148 9.29732C5.01846 9.29732 4.92308 9.27834 4.83408 9.24146C4.74509 9.20459 4.66423 9.15054 4.59613 9.08241L0.872129 5.35841C0.810189 5.29647 0.761055 5.22294 0.727533 5.14201C0.694011 5.06108 0.676758 4.97434 0.676758 4.88674C0.676758 4.79915 0.694011 4.71241 0.727533 4.63148C0.761055 4.55055 0.810189 4.47702 0.872129 4.41508C0.934069 4.35314 1.0076 4.304 1.08853 4.27048C1.16946 4.23696 1.2562 4.21971 1.3438 4.21971C1.43139 4.21971 1.51813 4.23696 1.59906 4.27048C1.67999 4.304 1.75352 4.35314 1.81546 4.41508L5.11546 7.71508L12.1848 0.64441C12.3098 0.519429 12.4794 0.449219 12.6561 0.449219C12.8329 0.449219 13.0031 0.519429 13.1281 0.64441Z",
    fill: "#C5DEA1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmed);
export default __webpack_public_path__ + "static/media/confirmed.d8ad1376e36b405519b1892d99c32d4f.svg";
export { ForwardRef as ReactComponent };